module.exports = __webpack_public_path__ + "static/media/gh.e630fe6a.png";